import React from 'react'
import { Icon } from 'semantic-ui-react'

function SampleRow({ row }) {
  const [open, setOpen] = React.useState(false)
  return (
    <div style={{marginBottom: 12}}>
      <div
        style={{cursor: 'pointer'}}
        onClick={() => setOpen(!open)}
      >
        <Icon name={open ? 'chevron down' : 'chevron right'} />
        {row.name}
      </div>
      {open &&
        <div style={{fontSize: 12, color: '#888', marginTop: 4}}>
          {row.note}
          {row.url &&
            <div>
              <a href={row.url} onClick={(e) => {
                e.preventDefault()
                window.open(row.url, 'samplePdf', 'width=720,height=500,left=80,top=40')
              }}>
                Open sample PDF <Icon name="external" />
              </a>
            </div>
          }
          {row.url2 &&
            <div>
              <a href={row.url2} onClick={(e) => {
                e.preventDefault()
                window.open(row.url2, 'samplePdf', 'width=720,height=500,left=80,top=40')
              }}>
                Open sample PDF 2 <Icon name="external" />
              </a>
            </div>
          }
        </div>
      }
    </div>
  )
}

export {SampleRow}
